import {
  createContext,
  type ReactNode,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { authNe } from "./auth-ne";
import { marketingNe } from "./marketing-ne";

type Language = "en" | "ne";

const ne: Record<string, string> = {
  Features: "विशेषताहरू",
  Programs: "कार्यक्रमहरू",
  Rewards: "पुरस्कारहरू",
  Tiers: "टियरहरू",
  "For businesses": "व्यवसायका लागि",
  "Log in": "लग इन",
  "Log out": "लग आउट",
  "Join Mero Perks": "मेरो पर्क्समा जोडिनुहोस्",
  Explore: "खोज्नुहोस्",
  "Business map": "व्यवसाय नक्सा",
  "How it works": "कसरी काम गर्छ",
  "Create account": "खाता बनाउनुहोस्",
  Business: "व्यवसाय",
  "Partner with us": "हामीसँग साझेदार बन्नुहोस्",
  "Business Owner login": "व्यवसाय मालिक लग इन",
  Legal: "कानुनी",
  "Privacy Policy": "गोपनीयता नीति",
  "Cookie Policy": "कुकी नीति",
  "Terms & Conditions": "नियम तथा सर्तहरू",
  "Account deletion": "खाता मेटाउने",
  "Need help?": "सहयोग चाहिन्छ?",
  Workspace: "कार्यस्थल",
  "Platform admin": "प्लेटफर्म प्रशासक",
  "My rewards": "मेरा पुरस्कार",
  "Need a hand?": "सहयोग चाहिन्छ?",
  "Contact support": "सहयोग सम्पर्क",
  "Mero Checkout": "मेरो चेकआउट",
  "Choose a checkout operation": "चेकआउट प्रक्रिया छान्नुहोस्",
  "Record a member purchase or validate a one-time customer coupon from one workspace.": "एउटै कार्यस्थलबाट सदस्य खरिद रेकर्ड गर्नुहोस् वा ग्राहकको एकपटक प्रयोग हुने कुपन प्रमाणित गर्नुहोस्।",
  "Member Scan": "सदस्य स्क्यान",
  "Scan a member, apply balances, and record the sale.": "सदस्य स्क्यान गर्नुहोस्, उपलब्ध मौज्दात प्रयोग गर्नुहोस् र बिक्री रेकर्ड गर्नुहोस्।",
  "Coupon Scan": "कुपन स्क्यान",
  "Scan or enter a coupon and redeem it securely.": "कुपन स्क्यान वा प्रविष्ट गरी सुरक्षित रूपमा रिडिम गर्नुहोस्।",
  Redemption: "रिडेम्प्सन",
  "Business Rules": "व्यवसाय नियम",
  Locations: "स्थानहरू",
  Province: "प्रदेश",
  District: "जिल्ला",
  "Local level / municipality": "स्थानीय तह / नगरपालिका",
  "Select province": "प्रदेश छान्नुहोस्",
  "Select district": "जिल्ला छान्नुहोस्",
  "Select local level": "स्थानीय तह छान्नुहोस्",
  Inventory: "सामान सूची",
  "Quick Offers": "द्रुत अफरहरू",
  "Total items": "कुल सामान",
  "Products and services": "उत्पादन र सेवाहरू",
  "Active items": "सक्रिय सामान",
  "Available for Quick Offers": "द्रुत अफरका लागि उपलब्ध",
  "Low stock": "कम मौज्दात",
  "Five or fewer remaining": "पाँच वा कम बाँकी",
  "Offer eligibility": "अफर योग्यता",
  "Add items once, then select them while building a Quick Offer so customers know exactly what qualifies.": "सामान एकपटक थप्नुहोस्, त्यसपछि द्रुत अफर बनाउँदा योग्य सामान चयन गर्नुहोस् ताकि ग्राहकले स्पष्ट रूपमा बुझून्।",
  "Add inventory item": "सामान सूचीमा थप्नुहोस्",
  "Close form": "फारम बन्द गर्नुहोस्",
  "Add an inventory item": "सामान सूचीमा नयाँ वस्तु थप्नुहोस्",
  "Edit inventory item": "सामान विवरण सम्पादन गर्नुहोस्",
  "Keep item details clear so your team can apply offers consistently.": "तपाईंको टोलीले अफर समान रूपमा लागू गर्न सक्ने गरी सामान विवरण स्पष्ट राख्नुहोस्।",
  "Item code": "सामान कोड",
  "Item or service name": "सामान वा सेवाको नाम",
  "Brand (optional)": "ब्रान्ड (वैकल्पिक)",
  Category: "श्रेणी",
  "Regular price (NPR)": "नियमित मूल्य (नेरु)",
  "Stock quantity (optional)": "मौज्दात परिमाण (वैकल्पिक)",
  "Item image URL (optional)": "सामानको तस्बिर URL (वैकल्पिक)",
  "Offer image": "अफरको तस्बिर",
  "No image selected": "तस्बिर चयन गरिएको छैन",
  "Upload a JPG, PNG, or WebP image up to 5 MB. On a phone, you can take a new picture.": "५ MB सम्मको JPG, PNG वा WebP तस्बिर अपलोड गर्नुहोस्। फोनमा नयाँ तस्बिर खिच्न पनि सक्नुहुन्छ।",
  "Upload or take picture": "अपलोड गर्नुहोस् वा तस्बिर खिच्नुहोस्",
  "Remove image": "तस्बिर हटाउनुहोस्",
  Status: "स्थिति",
  "Save changes": "परिवर्तन सुरक्षित गर्नुहोस्",
  "Search inventory": "सामान सूची खोज्नुहोस्",
  "All statuses": "सबै स्थिति",
  "No inventory items match": "मिल्ने सामान भेटिएन",
  "Adjust the filters or add the first product or service for your Quick Offers.": "फिल्टर परिवर्तन गर्नुहोस् वा द्रुत अफरका लागि पहिलो उत्पादन वा सेवा थप्नुहोस्।",
  "Turn everyday visits into reasons to return": "हरेक भ्रमणलाई फेरि फर्किने कारण बनाउनुहोस्",
  "Create item offers, punch-card rewards, discounts, and coupons; then control approval, scheduling, limits, and availability.": "सामान अफर, पञ्च कार्ड पुरस्कार, छुट र कुपन बनाउनुहोस्; त्यसपछि स्वीकृति, तालिका, सीमा र उपलब्धता नियन्त्रण गर्नुहोस्।",
  "New Quick Offer": "नयाँ द्रुत अफर",
  "Loading Quick Offers": "द्रुत अफरहरू लोड हुँदैछन्",
  "No Quick Offers match these filters": "यी फिल्टरसँग मिल्ने द्रुत अफर छैन",
  "Adjust the search or build a new offer for your customers.": "खोज परिवर्तन गर्नुहोस् वा ग्राहकका लागि नयाँ अफर बनाउनुहोस्।",
  "Create Quick Offer": "द्रुत अफर बनाउनुहोस्",
  "QUICK OFFER": "द्रुत अफर",
  "Create a Quick Offer": "द्रुत अफर बनाउनुहोस्",
  "Edit Quick Offer": "द्रुत अफर सम्पादन गर्नुहोस्",
  "Choose a benefit, add the essentials, and make it available to customers.": "लाभ छान्नुहोस्, आवश्यक विवरण थप्नुहोस् र ग्राहकका लागि उपलब्ध गराउनुहोस्।",
  "Offer details": "अफर विवरण",
  "Name, image, and appearance": "नाम, तस्बिर र रूप",
  "Benefit and eligible items": "लाभ र योग्य वस्तुहरू",
  "Quantity, dates, and terms": "मात्रा, मिति र सर्तहरू",
  "Keep it clear enough to understand at a glance.": "एकै नजरमा बुझिने गरी स्पष्ट राख्नुहोस्।",
  "Offer name": "अफरको नाम",
  "Customer description": "ग्राहक विवरण",
  "Offer appearance": "अफरको रूप",
  "Choose how this offer card looks to customers.": "ग्राहकलाई अफर कार्ड कस्तो देखिन्छ छान्नुहोस्।",
  Crimson: "गाढा रातो",
  Gold: "सुनौलो",
  Cream: "क्रिम",
  Navy: "गाढा निलो",
  "Choose the offer": "अफर छान्नुहोस्",
  "Only fields needed for this offer type will appear.": "यस अफर प्रकारका लागि आवश्यक विवरण मात्र देखिनेछन्।",
  "Points reward": "अंक पुरस्कार",
  "Exchange business points for an offer.": "व्यवसाय अंक साटेर अफर लिनुहोस्।",
  "Amount off": "निश्चित रकम छुट",
  "Take a fixed amount off a purchase.": "खरिदमा निश्चित रकम छुट दिनुहोस्।",
  "Percentage off": "प्रतिशत छुट",
  "Discount a qualifying purchase by percent.": "योग्य खरिदमा प्रतिशत छुट दिनुहोस्।",
  "Free item": "निःशुल्क वस्तु",
  "Give a product or service at no cost.": "उत्पादन वा सेवा निःशुल्क दिनुहोस्।",
  "Buy one, get one": "एउटा किन्दा एउटा निःशुल्क",
  "Buy a quantity and receive another free.": "तोकिएको मात्रा किन्दा अर्को निःशुल्क दिनुहोस्।",
  "Punch card": "पञ्च कार्ड",
  "Reward repeat visits or item purchases.": "दोहोरिएको भ्रमण वा वस्तु खरिदमा पुरस्कार दिनुहोस्।",
  "Business points required": "आवश्यक व्यवसाय अंक",
  "Discount percentage": "छुट प्रतिशत",
  "Amount off (NPR)": "छुट रकम (नेरु)",
  "Maximum discount (NPR)": "अधिकतम छुट (नेरु)",
  "Free item or service": "निःशुल्क वस्तु वा सेवा",
  "Buy quantity": "किन्नुपर्ने मात्रा",
  "Free quantity": "निःशुल्क मात्रा",
  "What earns a punch?": "के गर्दा पञ्च पाइन्छ?",
  "One verified visit / checkout": "एक प्रमाणित भ्रमण / चेकआउट",
  "Each selected item purchased": "प्रत्येक चयनित वस्तु खरिद",
  "Punches required": "आवश्यक पञ्च",
  "Qualifying purchase": "योग्य खरिद",
  "Free reward issued": "दिइने निःशुल्क पुरस्कार",
  "Repeat the punch card": "पञ्च कार्ड दोहोर्याउनुहोस्",
  "Start a new card after every completed cycle.": "प्रत्येक पूरा चक्रपछि नयाँ कार्ड सुरु गर्नुहोस्।",
  "Minimum purchase (NPR)": "न्यूनतम खरिद (नेरु)",
  "Eligible inventory": "योग्य सामान सूची",
  "(optional unless Buy one, get one)": "(एउटा किन्दा एउटा निःशुल्क बाहेक वैकल्पिक)",
  "Add products or services in Inventory when this offer should apply only to selected items.": "यो अफर चयनित वस्तुमा मात्र लागू हुने भए सामान सूचीमा उत्पादन वा सेवा थप्नुहोस्।",
  Availability: "उपलब्धता",
  "Set simple limits now. Advanced campaigns remain in Rewards Management.": "अहिले सामान्य सीमा सेट गर्नुहोस्। उन्नत अभियान पुरस्कार व्यवस्थापनमै रहनेछन्।",
  "Available quantity": "उपलब्ध मात्रा",
  "Maximum per customer": "प्रति ग्राहक अधिकतम",
  Starts: "सुरु",
  Ends: "अन्त्य",
  "Feature this offer": "यो अफर विशेष रूपमा देखाउनुहोस्",
  "Highlight it in customer discovery.": "ग्राहक खोजमा यसलाई प्राथमिक रूपमा देखाउनुहोस्।",
  "Optional customer terms": "वैकल्पिक ग्राहक सर्तहरू",
  "CUSTOMER PREVIEW": "ग्राहक पूर्वावलोकन",
  "READY TO USE": "प्रयोगका लागि तयार",
  "Your offer name": "तपाईंको अफरको नाम",
  "A clear description will help customers understand this offer.": "स्पष्ट विवरणले ग्राहकलाई यो अफर बुझ्न मद्दत गर्छ।",
  "Quick and customer-ready": "छिटो र ग्राहकका लागि तयार",
  "You can add advanced audiences, campaigns, approval paths, and budget controls later in Rewards Management.": "उन्नत ग्राहक समूह, अभियान, स्वीकृति प्रक्रिया र बजेट नियन्त्रण पछि पुरस्कार व्यवस्थापनमा थप्न सकिन्छ।",
  "Save draft": "मस्यौदा सुरक्षित गर्नुहोस्",
  Continue: "अर्को चरण",
  "Publish Quick Offer": "द्रुत अफर प्रकाशित गर्नुहोस्",
  "Save & submit": "सुरक्षित गरी पेस गर्नुहोस्",
  "Rewards Management": "पुरस्कार व्यवस्थापन",
  "Rewards Dashboard": "पुरस्कार ड्यासबोर्ड",
  "Reward Catalog / Offers & Coupons": "पुरस्कार सूची / अफर र कुपन",
  Calendar: "पात्रो",
  Approvals: "स्वीकृतिहरू",
  "Liability & Budget": "दायित्व र बजेट",
  Analytics: "विश्लेषण",
  Campaigns: "अभियानहरू",
  Segments: "समूहहरू",
  Automations: "स्वचालन",
  "Mero Credits": "मेरो क्रेडिट",
  "Mero Tier Points": "मेरो टियर अंक",
  Account: "खाता",
  Home: "गृह",
  "Digital Card": "डिजिटल कार्ड",
  "My Wallet": "मेरो वालेट",
  "My Rewards": "मेरा पुरस्कार",
  "Offers & Coupons": "अफर र कुपन",
  Activity: "गतिविधि",
  Profile: "प्रोफाइल",
  Settings: "सेटिङहरू",
  "Complete your Account Setup": "आफ्नो खाता सेटअप पूरा गर्नुहोस्",
  "Earning rule": "कमाइ नियम",
  "Redemption rule": "रिडेम्प्सन नियम",
  "First Quick Offer": "पहिलो द्रुत अफर",
  "Start guided setup": "निर्देशित सेटअप सुरु गर्नुहोस्",
  "ACCOUNT SETUP": "खाता सेटअप",
  "BUSINESS ACCOUNT SETUP": "व्यवसाय खाता सेटअप",
  "Build your loyalty foundation": "आफ्नो लोयल्टी आधार तयार गर्नुहोस्",
  "Complete these three steps in order. Nothing is published until you review and confirm it.":
    "यी तीन चरण क्रमसँग पूरा गर्नुहोस्। तपाईंले समीक्षा र पुष्टि नगरेसम्म केही पनि प्रकाशित हुँदैन।",
  "How customers earn": "ग्राहकले कसरी अंक कमाउँछन्",
  "How customers use points": "ग्राहकले अंक कसरी प्रयोग गर्छन्",
  "Your first live reward": "तपाईंको पहिलो प्रत्यक्ष पुरस्कार",
  "STEP 1 · EARNING RULE": "चरण १ · कमाइ नियम",
  "Choose how customers earn points": "ग्राहकले अंक कसरी कमाउँछन् छान्नुहोस्",
  "Start with clear defaults, then review and publish the rule yourself.":
    "स्पष्ट पूर्वनिर्धारित मानबाट सुरु गर्नुहोस्, त्यसपछि नियम समीक्षा गरी आफैं प्रकाशित गर्नुहोस्।",
  "Spend unit (NPR)": "खर्च एकाइ (नेरु)",
  "The purchase amount represented by one earning unit.": "एउटा कमाइ एकाइले जनाउने खरिद रकम।",
  "Points per unit": "प्रति एकाइ अंक",
  "Points awarded for every full spend unit.": "प्रत्येक पूरा खर्च एकाइमा दिइने अंक।",
  "Minimum qualifying purchase (NPR)": "न्यूनतम योग्य खरिद (नेरु)",
  "Maximum points per purchase": "प्रति खरिद अधिकतम अंक",
  "Point expiration days": "अंकको म्याद अवधि (दिन)",
  "Saving creates a draft only. You will review and publish it next.":
    "सेभ गर्दा मस्यौदा मात्र बन्छ। अर्को चरणमा तपाईंले समीक्षा गरी प्रकाशित गर्नुहुनेछ।",
  "REVIEW EARNING RULE": "कमाइ नियम समीक्षा",
  "The draft is saved. Review the values before making it active.":
    "मस्यौदा सेभ भयो। सक्रिय बनाउनुअघि मानहरू समीक्षा गर्नुहोस्।",
  "Minimum purchase": "न्यूनतम खरिद",
  "Points limit": "अंक सीमा",
  "No limit": "कुनै सीमा छैन",
  "STEP 2 · REDEMPTION RULE": "चरण २ · रिडेम्प्सन नियम",
  "Set the value customers can use": "ग्राहकले प्रयोग गर्न सक्ने मूल्य निर्धारण गर्नुहोस्",
  "Define how this business converts its own Reward Points at checkout.":
    "यो व्यवसायले चेकआउटमा आफ्नै पुरस्कार अंक कसरी रूपान्तरण गर्छ निर्धारण गर्नुहोस्।",
  "Value (NPR)": "मूल्य (नेरु)",
  "Points used for one conversion unit.": "एउटा रूपान्तरण एकाइमा प्रयोग हुने अंक।",
  "Discount produced by each conversion unit.": "प्रत्येक रूपान्तरण एकाइबाट प्राप्त छुट।",
  "Minimum points per redemption": "प्रति रिडेम्प्सन न्यूनतम अंक",
  "Maximum points per checkout": "प्रति चेकआउट अधिकतम अंक",
  "Review this conversion before publishing it.": "प्रकाशनअघि यो रूपान्तरण समीक्षा गर्नुहोस्।",
  "Review redemption rule": "रिडेम्प्सन नियम समीक्षा गर्नुहोस्",
  "REVIEW REDEMPTION RULE": "रिडेम्प्सन नियम समीक्षा",
  "Publish this redemption rule?": "यो रिडेम्प्सन नियम प्रकाशित गर्ने?",
  "This conversion applies only to Reward Points earned at this business.":
    "यो रूपान्तरण यस व्यवसायमा कमाइएका पुरस्कार अंकमा मात्र लागू हुन्छ।",
  Conversion: "रूपान्तरण",
  "Minimum redemption": "न्यूनतम रिडेम्प्सन",
  "Checkout limit": "चेकआउट सीमा",
  "Edit rule": "नियम सम्पादन गर्नुहोस्",
  "Publish redemption rule": "रिडेम्प्सन नियम प्रकाशित गर्नुहोस्",
  "Your earning rule is active": "तपाईंको कमाइ नियम सक्रिय छ",
  "Continue when you are ready to define how customers redeem those points.":
    "ग्राहकले ती अंक कसरी रिडिम गर्छन् निर्धारण गर्न तयार भएपछि जारी राख्नुहोस्।",
  "REDEMPTION RULE PUBLISHED": "रिडेम्प्सन नियम प्रकाशित भयो",
  "Customers now know what their points are worth": "अब ग्राहकलाई आफ्ना अंकको मूल्य थाहा हुन्छ",
  "Continue to publish one simple offer customers can discover and use.":
    "ग्राहकले भेट्टाउन र प्रयोग गर्न सक्ने एउटा सरल अफर प्रकाशित गर्न जारी राख्नुहोस्।",
  "Continue to first Quick Offer": "पहिलो द्रुत अफरमा जारी राख्नुहोस्",
  "ACCOUNT SETUP COMPLETE": "खाता सेटअप पूरा भयो",
  "Your business is ready for customers": "तपाईंको व्यवसाय ग्राहकका लागि तयार छ",
  "The earning rule, redemption rule, and first Quick Offer are live. Your full Business Owner workspace is now unlocked.":
    "कमाइ नियम, रिडेम्प्सन नियम र पहिलो द्रुत अफर प्रत्यक्ष छन्। अब तपाईंको पूरा व्यवसाय मालिक कार्यस्थल खुला छ।",
  "Open business workspace": "व्यवसाय कार्यस्थल खोल्नुहोस्",
  "Setup access is required": "सेटअप पहुँच आवश्यक छ",
  "Preparing your account setup…": "खाता सेटअप तयार हुँदैछ…",
  "Loading redemption defaults…": "रिडेम्प्सन पूर्वनिर्धारित मान लोड हुँदैछ…",
  "Loading Quick Offer tools…": "द्रुत अफर उपकरण लोड हुँदैछ…",
  "Publish an offer available now": "अहिले उपलब्ध हुने अफर प्रकाशित गर्नुहोस्",
  "Draft or future-scheduled offers do not complete Business Account Setup.":
    "मस्यौदा वा भविष्यका लागि तय गरिएका अफरले व्यवसाय खाता सेटअप पूरा गर्दैनन्।",
  "Create earning rule": "कमाइ नियम बनाउनुहोस्",
  "Create redemption rule": "रिडेम्प्सन नियम बनाउनुहोस्",
  "Create first Quick Offer": "पहिलो द्रुत अफर बनाउनुहोस्",
  "Rules History": "नियम इतिहास",
  "Business Reward Points": "व्यवसाय पुरस्कार अंक",
  "Reward Point redemption rule": "पुरस्कार अंक रिडेम्प्सन नियम",
  "Checkout Controls": "चेकआउट नियन्त्रण",
  "Add new Checkout Control": "नयाँ चेकआउट नियन्त्रण थप्नुहोस्",
  Save: "सेभ गर्नुहोस्",
  Cancel: "रद्द गर्नुहोस्",
  Edit: "सम्पादन",
  Delete: "मेटाउनुहोस्",
  Protected: "सुरक्षित",
  "Super Admin accounts are protected from deletion.":
    "सुपर एडमिन खाताहरू मेटाउनबाट सुरक्षित छन्।",
  "Delete and archive this user account": "यो प्रयोगकर्ता खाता मेटाएर अभिलेख गर्नुहोस्",
  "Permanent account action": "स्थायी खाता कार्य",
  "Delete and archive": "मेटाएर अभिलेख गर्नुहोस्",
  "Delete & archive business": "व्यवसाय मेटाएर अभिलेख गर्नुहोस्",
  "Delete & archive user": "प्रयोगकर्ता मेटाएर अभिलेख गर्नुहोस्",
  Type: "टाइप गर्नुहोस्",
  "to confirm": "पुष्टि गर्न",
  "This action removes the account from the live platform and cannot be undone.":
    "यस कार्यले खातालाई प्रत्यक्ष प्लेटफर्मबाट हटाउँछ र यसलाई पूर्ववत् गर्न सकिँदैन।",
  "Staff access, locations, offers, rewards, inventory, transactions, and related business data will leave the live platform.":
    "कर्मचारी पहुँच, स्थान, अफर, पुरस्कार, सामान सूची, कारोबार र सम्बन्धित व्यवसाय डेटा प्रत्यक्ष प्लेटफर्मबाट हट्नेछन्।",
  "The business PAN number and Business Owner email registration will be released for a future account.":
    "व्यवसायको प्यान नम्बर र व्यवसाय मालिक इमेल दर्ता भविष्यको खाताका लागि उपलब्ध गराइनेछ।",
  "Shared customer accounts will not be deleted.":
    "साझा ग्राहक खाताहरू मेटाइने छैनन्।",
  "Every active session will be revoked and this profile, its memberships, balances, rewards, and account activity will leave the live platform.":
    "सबै सक्रिय सत्र रद्द हुनेछन् र यो प्रोफाइल, सदस्यता, मौज्दात, पुरस्कार र खाता गतिविधि प्रत्यक्ष प्लेटफर्मबाट हट्नेछन्।",
  "The email address will be released for a new account.":
    "इमेल ठेगाना नयाँ खाताका लागि उपलब्ध गराइनेछ।",
  "Business transaction records remain preserved in the archive for audit. A protected or sole-owner account may need another owner before it can be deleted.":
    "व्यवसाय कारोबार अभिलेख परीक्षणका लागि सुरक्षित रहनेछन्। सुरक्षित वा एकल-मालिक खातालाई मेटाउनुअघि अर्को मालिक आवश्यक पर्न सक्छ।",
  "Cancel deletion": "मेटाउने कार्य रद्द गर्नुहोस्",
  "Archiving…": "अभिलेख हुँदैछ…",
  Archive: "अभिलेख",
  Refresh: "रिफ्रेस",
  Submit: "पेस गर्नुहोस्",
  Approve: "स्वीकृत",
  Reject: "अस्वीकृत",
  Activate: "सक्रिय गर्नुहोस्",
  Pause: "रोक्नुहोस्",
  Active: "सक्रिय",
  Draft: "मस्यौदा",
  "EARNING RULE PUBLISHED": "कमाइ नियम प्रकाशित भयो",
  "Your earning rule is active.": "तपाईंको कमाइ नियम सक्रिय छ।",
  "The rule is published, but Mero Perks will not move to the next setup step until you choose to continue.":
    "नियम प्रकाशित भएको छ, तर तपाईंले जारी राख्न नछानेसम्म मेरो पर्क्स अर्को सेटअप चरणमा जाने छैन।",
  "Continue to redemption rule": "रिडेम्प्सन नियममा जारी राख्नुहोस्",
  "Review draft": "मस्यौदा समीक्षा गर्नुहोस्",
  "Publish this earning rule?": "यो कमाइ नियम प्रकाशित गर्ने?",
  "Your draft is saved. Publishing is a separate action and will make this version active.":
    "तपाईंको मस्यौदा सुरक्षित भयो। प्रकाशन छुट्टै कार्य हो र यसले यो संस्करणलाई सक्रिय बनाउनेछ।",
  "Earning rate": "कमाइ दर",
  "Minimum spend": "न्यूनतम खर्च",
  "Transaction limit": "कारोबार सीमा",
  "No cap": "कुनै सीमा छैन",
  Expiration: "म्याद",
  "Points do not expire": "अंकको म्याद सकिँदैन",
  days: "दिन",
  "Edit draft": "मस्यौदा सम्पादन गर्नुहोस्",
  "Publishing…": "प्रकाशन हुँदैछ…",
  "Publish earning rule": "कमाइ नियम प्रकाशित गर्नुहोस्",
  "Draft version": "मस्यौदा संस्करण",
  "Save version": "संस्करण सुरक्षित गर्नुहोस्",
  "as a draft, review it, and publish only when you are ready.":
    "मस्यौदाका रूपमा सुरक्षित गरी समीक्षा गर्नुहोस् र तयार भएपछि मात्र प्रकाशित गर्नुहोस्।",
  "Saving keeps this rule in draft until you explicitly publish it.":
    "तपाईंले स्पष्ट रूपमा प्रकाशित नगरेसम्म सुरक्षित गर्दा यो नियम मस्यौदामै रहन्छ।",
  "Saving draft…": "मस्यौदा सुरक्षित हुँदैछ…",
  "Save draft and review": "मस्यौदा सुरक्षित गरी समीक्षा गर्नुहोस्",
  Archived: "अभिलेखित",
  Retired: "सेवानिवृत्त",
  "Customer sign in": "ग्राहक साइन इन",
  "Business Owner sign in": "व्यवसाय मालिक साइन इन",
  Email: "इमेल",
  Password: "पासवर्ड",
  "Remember business code": "व्यवसाय कोड सम्झनुहोस्",
  "Remember business email": "व्यवसाय इमेल सम्झनुहोस्",
  "New business?": "नयाँ व्यवसाय?",
  "Create Business Owner account": "व्यवसाय मालिक खाता बनाउनुहोस्",
  "Profile saved.": "प्रोफाइल सेभ भयो।",
  "Preferences saved.": "प्राथमिकताहरू सेभ भए।",
  "Edit profile": "प्रोफाइल सम्पादन",
  "Upload picture": "तस्बिर अपलोड",
  "Take picture": "तस्बिर खिच्नुहोस्",
  "Remove photo": "तस्बिर हटाउनुहोस्",
  "Personal details": "व्यक्तिगत विवरण",
  "Communication preferences": "सञ्चार प्राथमिकता",
  "Sign in to continue": "जारी राख्न साइन इन गर्नुहोस्",
  "Try again": "फेरि प्रयास गर्नुहोस्",
  Loading: "लोड हुँदैछ",
  "No records are available for this area yet.": "यस क्षेत्रमा अझै रेकर्ड उपलब्ध छैन।",
  Search: "खोज्नुहोस्",
  "Featured perks": "विशेष सुविधाहरू",
  "Available now": "अहिले उपलब्ध",
  Points: "अंक",
  "Browse businesses": "व्यवसायहरू हेर्नुहोस्",
  "Browse rewards": "पुरस्कारहरू हेर्नुहोस्",
  "EXPLORE MERO PERKS": "मेरो पर्क्स खोज्नुहोस्",
  "Find a place you’ll want to come back to.": "फेरि जान मन लाग्ने ठाउँ खोज्नुहोस्।",
  "Discover stores, restaurants, cafés, hotels, rewards, and Mero Credits locations near you.":
    "आफू नजिकका पसल, रेस्टुरेन्ट, क्याफे, होटल, पुरस्कार र मेरो क्रेडिट स्वीकार्ने स्थानहरू खोज्नुहोस्।",
  "Search businesses or areas": "व्यवसाय वा क्षेत्र खोज्नुहोस्",
  "Search business, category, or area": "व्यवसाय, श्रेणी वा क्षेत्र खोज्नुहोस्",
  "Clear search": "खोज हटाउनुहोस्",
  "Business type filters": "व्यवसाय प्रकार फिल्टर",
  "Open now": "अहिले खुला",
  Clear: "हटाउनुहोस्",
  "Sort businesses": "व्यवसाय क्रमबद्ध गर्नुहोस्",
  Recommended: "सिफारिस गरिएको",
  "Business: A to Z": "व्यवसाय: क देखि ज्ञ",
  "Most rewards": "सबैभन्दा धेरै पुरस्कार",
  "Nearest first": "नजिकको पहिले",
  "Near me": "मेरो नजिक",
  "Marketplace view": "मार्केटप्लेस दृश्य",
  List: "सूची",
  Map: "नक्सा",
  "Map of businesses with pinned locations": "ठेगाना पिन गरिएका व्यवसायहरूको नक्सा",
  "Sorted by distance": "दूरीअनुसार क्रमबद्ध",
  "Search an area or use Near me for distance":
    "क्षेत्र खोज्नुहोस् वा दूरीका लागि मेरो नजिक प्रयोग गर्नुहोस्",
  business: "व्यवसाय",
  businesses: "व्यवसायहरू",
  "with pinned locations": "पिन गरिएका स्थानसहित",
  "Locations available": "स्थानहरू उपलब्ध",
  rewards: "पुरस्कारहरू",
  reward: "पुरस्कार",
  Credits: "क्रेडिट",
  "View business": "व्यवसाय हेर्नुहोस्",
  "No businesses with pinned locations": "पिन गरिएको स्थान भएका व्यवसाय भेटिएनन्",
  "Clear a filter or search another area.": "फिल्टर हटाउनुहोस् वा अर्को क्षेत्र खोज्नुहोस्।",
  "Search this area": "यो क्षेत्र खोज्नुहोस्",
  "No businesses match yet": "अहिलेसम्म मिल्ने व्यवसाय भेटिएनन्",
  "Clear a filter, search a broader area, or browse without your location.":
    "फिल्टर हटाउनुहोस्, फराकिलो क्षेत्र खोज्नुहोस् वा आफ्नो स्थानबिना हेर्नुहोस्।",
  "Clear filters": "फिल्टर हटाउनुहोस्",
  "Finding Mero Perks businesses": "मेरो पर्क्स व्यवसायहरू खोजिँदैछ",
  "Loading locations and current reward availability.":
    "स्थान र हालको पुरस्कार उपलब्धता लोड हुँदैछ।",
  "Marketplace is temporarily unavailable": "मार्केटप्लेस अस्थायी रूपमा उपलब्ध छैन",
  "Requesting your location. Mero Perks uses it only to sort this page and does not store it.":
    "तपाईंको स्थान अनुरोध गरिँदैछ। मेरो पर्क्सले यो पृष्ठ क्रमबद्ध गर्न मात्र प्रयोग गर्छ र भण्डारण गर्दैन।",
  "Nearby results are sorted from your current position.":
    "नजिकका नतिजा तपाईंको हालको स्थानबाट दूरीअनुसार क्रमबद्ध छन्।",
  "Location access was not granted. Search by business or area instead.":
    "स्थान पहुँच अनुमति दिइएन। यसको सट्टा व्यवसाय वा क्षेत्रबाट खोज्नुहोस्।",
  "Live reward marketplace": "प्रत्यक्ष पुरस्कार बजार",
  "Browse available rewards.": "उपलब्ध पुरस्कारहरू हेर्नुहोस्।",
  "Search every currently available Mero Perks reward by business, category, value, or expiry. Sign in only when you are ready to redeem.":
    "हाल उपलब्ध सबै मेरो पर्क्स पुरस्कारलाई व्यवसाय, श्रेणी, मूल्य वा म्यादअनुसार खोज्नुहोस्। रिडिम गर्न तयार भएपछि मात्र लग इन गर्नुहोस्।",
  "available now": "अहिले उपलब्ध",
  "Search rewards": "पुरस्कार खोज्नुहोस्",
  "Search rewards, categories, or businesses": "पुरस्कार, श्रेणी वा व्यवसाय खोज्नुहोस्",
  "Filter rewards by business": "व्यवसायअनुसार पुरस्कार फिल्टर गर्नुहोस्",
  "All partners": "सबै साझेदार",
  "Sort rewards": "पुरस्कार क्रमबद्ध गर्नुहोस्",
  "Points: low to high": "अंक: कमदेखि धेरै",
  "Points: high to low": "अंक: धेरैदेखि कम",
  "Expiring soon": "चाँडै म्याद सकिने",
  "Filter rewards by category": "श्रेणीअनुसार पुरस्कार फिल्टर गर्नुहोस्",
  "All rewards": "सबै पुरस्कार",
  "Show more rewards": "थप पुरस्कार देखाउनुहोस्",
  "Rewards are temporarily unavailable": "पुरस्कारहरू अस्थायी रूपमा उपलब्ध छैनन्",
  "We could not reach the live catalogue. Please try again shortly.":
    "प्रत्यक्ष सूचीमा पुग्न सकिएन। कृपया केही बेरमा फेरि प्रयास गर्नुहोस्।",
  "Retry catalogue": "सूची पुनः प्रयास गर्नुहोस्",
  "Gathering rewards": "पुरस्कारहरू सङ्कलन हुँदैछ",
  "No available rewards match those filters": "ती फिल्टरसँग मिल्ने उपलब्ध पुरस्कार छैनन्",
  "Try another business or category, or clear your search.":
    "अर्को व्यवसाय वा श्रेणी छान्नुहोस्, वा खोज हटाउनुहोस्।",
  Platform: "प्लेटफर्म",
  "For business": "व्यवसायका लागि",
  Solutions: "समाधानहरू",
  Resources: "स्रोतहरू",
  "Rewards marketplace": "पुरस्कार बजार",
  "Discover and use offers from local businesses.":
    "स्थानीय व्यवसायका अफरहरू खोज्नुहोस् र प्रयोग गर्नुहोस्।",
  "Member wallet": "सदस्य वालेट",
  "Keep points, Mero Credits, and activity together.":
    "अंक, मेरो क्रेडिट र गतिविधि एउटै ठाउँमा राख्नुहोस्।",
  "Membership tiers": "सदस्यता तहहरू",
  "Grow from Mero to Elite across the network.": "सञ्जालभरि मेरोदेखि एलिटसम्म अघि बढ्नुहोस्।",
  "Platform-wide value at participating businesses.":
    "सहभागी व्यवसायहरूमा प्लेटफर्मभरि प्रयोग हुने मूल्य।",
  "Business platform": "व्यवसाय प्लेटफर्म",
  "See the complete Mero Perks business workspace.":
    "सम्पूर्ण मेरो पर्क्स व्यवसाय कार्यस्थल हेर्नुहोस्।",
  "Quick offers": "द्रुत अफरहरू",
  "Launch useful promotions without complexity.": "जटिलताबिना उपयोगी प्रवर्द्धन सुरु गर्नुहोस्।",
  "Checkout & redemption": "चेकआउट र रिडेम्प्सन",
  "Earn, redeem, and scan securely in one flow.":
    "एउटै प्रक्रियामा सुरक्षित रूपमा कमाउनुहोस्, रिडिम गर्नुहोस् र स्क्यान गर्नुहोस्।",
  "Customer insights": "ग्राहक अन्तर्दृष्टि",
  "Understand visits, rewards, and return behavior.":
    "भ्रमण, पुरस्कार र फर्कने व्यवहार बुझ्नुहोस्।",
  Retail: "खुद्रा",
  "Food & beverage": "खाना र पेय",
  "Hotels & stays": "होटल र बसाइ",
  "Small business": "साना व्यवसाय",
  "How Mero Perks works": "मेरो पर्क्स कसरी काम गर्छ",
  "Member benefits": "सदस्य सुविधाहरू",
  "Business pricing": "व्यवसाय मूल्य योजना",
  "Frequently asked questions": "बारम्बार सोधिने प्रश्नहरू",
  Cafe: "क्याफे",
  Café: "क्याफे",
  Grocery: "किराना",
  Hospitality: "आतिथ्य",
  Shopping: "किनमेल",
  Travel: "यात्रा",
  Language: "भाषा",
  English: "अङ्ग्रेजी",
  Nepali: "नेपाली",
  "Nepal's neighborhood rewards network": "नेपालको छिमेकी पुरस्कार सञ्जाल",
  "Make every visit": "हरेक भ्रमणलाई",
  "worth coming back for.": "फेरि फर्कन लायक बनाउनुहोस्।",
  "One free membership connects the places you already love with points, useful rewards, shared Mero Credits, and a status that grows with you.":
    "एउटा निःशुल्क सदस्यताले तपाईंलाई मनपर्ने ठाउँहरूलाई अंक, उपयोगी पुरस्कार, साझा मेरो क्रेडिट र तपाईंसँगै बढ्ने सदस्यता तहसँग जोड्छ।",
  "Join free": "निःशुल्क जोडिनुहोस्",
  "Mero Perks for business": "व्यवसायका लागि मेरो पर्क्स",
  "Mero Perks network at a glance": "मेरो पर्क्स सञ्जालको एक झलक",
  "Live rewards": "प्रत्यक्ष पुरस्कारहरू",
  "Local businesses": "स्थानीय व्यवसायहरू",
  "Member tiers": "सदस्यता तहहरू",
  "A Mero Perks member sharing coffee with her mother at a neighborhood cafe":
    "छिमेकी क्याफेमा आमासँग कफी बाँड्दै गरेकी मेरो पर्क्स सदस्य",
  "Reward ready": "पुरस्कार तयार",
  "Your next coffee could be on the house.": "तपाईंको अर्को कफी निःशुल्क हुन सक्छ।",
  "Available rewards stay together in your member wallet.":
    "उपलब्ध पुरस्कारहरू तपाईंको सदस्य वालेटमा एउटै ठाउँमा रहन्छन्।",
  "One membership. More rewarding places.": "एउटा सदस्यता। थप पुरस्कार दिने ठाउँहरू।",
  "Mero Perks promise": "मेरो पर्क्सको प्रतिबद्धता",
  SHOP: "किनमेल",
  DINE: "भोजन",
  STAY: "बसाइ",
  EXPLORE: "खोज्नुहोस्",
  REPEAT: "फेरि जानुहोस्",
  CAFÉ: "क्याफे",
  "Everything in one membership": "सबै कुरा एउटै सदस्यतामा",
  "Loyalty made useful for real life.": "दैनिक जीवनका लागि उपयोगी लोयल्टी।",
  "Simple enough for your daily coffee. Flexible enough for every place you love.":
    "दैनिक कफीका लागि सरल। तपाईंलाई मनपर्ने हरेक ठाउँका लागि लचिलो।",
  "Mero Perks member benefits": "मेरो पर्क्स सदस्यका सुविधाहरू",
  "Earn locally": "स्थानीय रूपमा कमाउनुहोस्",
  "Collect Reward Points from each participating business you visit.":
    "तपाईं जाने प्रत्येक सहभागी व्यवसायबाट पुरस्कार अंक सङ्कलन गर्नुहोस्।",
  "Rewards ready": "पुरस्कारहरू तयार",
  "Keep available offers and secure one-time reward QR codes in one place.":
    "उपलब्ध अफर र सुरक्षित एकपटक प्रयोग हुने पुरस्कार QR कोड एउटै ठाउँमा राख्नुहोस्।",
  "One member wallet": "एउटा सदस्य वालेट",
  "See Reward Points, Mero Credits, and purchase activity clearly.":
    "पुरस्कार अंक, मेरो क्रेडिट र खरिद गतिविधि स्पष्ट रूपमा हेर्नुहोस्।",
  "Status that grows": "बढ्दै जाने सदस्यता तह",
  "Move from Mero to Elite as eligible activity builds your Tier Points.":
    "योग्य गतिविधिबाट टियर अंक बढाउँदै मेरोदेखि एलिटसम्म पुग्नुहोस्।",
  "Scan securely": "सुरक्षित रूपमा स्क्यान गर्नुहोस्",
  "Short-lived, one-time QR codes help protect membership and reward redemption.":
    "छोटो समयका लागि मान्य एकपटक प्रयोग हुने QR कोडले सदस्यता र पुरस्कार रिडेम्प्सन सुरक्षित राख्छ।",
  "Stay in control": "नियन्त्रणमा रहनुहोस्",
  "Always know what you earned, where it works, and when it is ready to use.":
    "तपाईंले के कमाउनुभयो, कहाँ प्रयोग हुन्छ र कहिले प्रयोग गर्न तयार हुन्छ सधैँ थाहा पाउनुहोस्।",
  "rewards available": "उपलब्ध पुरस्कारहरू",
  "participating businesses": "सहभागी व्यवसायहरू",
  "membership tiers": "सदस्यता तहहरू",
  "A reward for every kind of day": "हरेक दिनका लागि एउटा पुरस्कार",
  "Four places. Four different reasons to come back.": "चार ठाउँ। फेरि फर्कने चार फरक कारण।",
  "Explore the businesses that make everyday life more rewarding, with a distinct experience built for each category.":
    "हरेक श्रेणीका लागि छुट्टै अनुभवसहित दैनिक जीवनलाई थप पुरस्कारमय बनाउने व्यवसायहरू खोज्नुहोस्।",
  "A customer discovering local fashion in a Kathmandu boutique":
    "काठमाडौंको बुटिकमा स्थानीय फेसन खोज्दै गरेका ग्राहक",
  "Find something worth returning for.": "फेरि फर्कन मन लाग्ने केही भेट्टाउनुहोस्।",
  "Discover local style, useful finds, and rewards that make the next visit count.":
    "स्थानीय शैली, उपयोगी सामान र अर्को भ्रमणलाई अर्थपूर्ण बनाउने पुरस्कारहरू पत्ता लगाउनुहोस्।",
  "Explore retail": "खुद्रा व्यवसाय खोज्नुहोस्",
  "Friends enjoying dinner at a local Nepalese restaurant":
    "स्थानीय नेपाली रेस्टुरेन्टमा रात्रिभोज रमाउँदै गरेका साथीहरू",
  "Turn a good meal into the next one.": "राम्रो भोजनलाई अर्को भ्रमणको कारण बनाउनुहोस्।",
  "Earn something extra whenever you gather, celebrate, or simply eat well.":
    "भेला हुँदा, उत्सव मनाउँदा वा स्वादिष्ट भोजन गर्दा थप केही कमाउनुहोस्।",
  "Explore dining": "भोजन स्थल खोज्नुहोस्",
  "A barista serving coffee to a Mero Perks customer":
    "मेरो पर्क्स ग्राहकलाई कफी दिँदै गरेका बारिस्ता",
  "Make the daily stop feel special.": "दैनिक भेटलाई विशेष बनाउनुहोस्।",
  "Let every coffee run, quick catch-up, and familiar order move you closer to a perk.":
    "हरेक कफी, छोटो भेट र परिचित अर्डरले तपाईंलाई पुरस्कारको अझ नजिक पुर्‍याओस्।",
  "Browse cafe perks": "क्याफे पुरस्कारहरू हेर्नुहोस्",
  "Guests arriving at a boutique hotel in Nepal": "नेपालको बुटिक होटलमा आइपुगेका पाहुनाहरू",
  "Remember the welcome after checkout.": "चेकआउटपछि पनि स्वागत सम्झिरहनुहोस्।",
  "Turn memorable stays and warm hospitality into reasons to plan the next escape.":
    "यादगार बसाइ र न्यानो आतिथ्यलाई अर्को यात्राको कारण बनाउनुहोस्।",
  "Explore hospitality": "आतिथ्य व्यवसाय खोज्नुहोस्",
  "See loyalty in motion": "लोयल्टी कसरी चल्छ हेर्नुहोस्",
  "One visit. A clearer reason to return.": "एउटा भ्रमण। फेरि फर्कने स्पष्ट कारण।",
  "Follow a Mero Perks moment from checkout to the next visit. The journey advances automatically, or choose any step to explore it.":
    "चेकआउटदेखि अर्को भ्रमणसम्मको मेरो पर्क्स अनुभव हेर्नुहोस्। यात्रा आफैँ अघि बढ्छ वा कुनै चरण छानेर हेर्नुहोस्।",
  "Loyalty journey": "लोयल्टी यात्रा",
  Earn: "कमाउनुहोस्",
  Unlock: "खोल्नुहोस्",
  Redeem: "रिडिम गर्नुहोस्",
  Grow: "बढ्नुहोस्",
  "At checkout": "चेकआउटमा",
  "A visit becomes value.": "भ्रमण मूल्यमा बदलिन्छ।",
  "A secure member scan connects the purchase to the right business balance and tier progress.":
    "सुरक्षित सदस्य स्क्यानले खरिदलाई सही व्यवसायको ब्यालेन्स र टियर प्रगतिसँग जोड्छ।",
  "Aadi Coffee Shop Reward Points": "आदि कफी शप पुरस्कार अंक",
  "Right on time": "सही समयमा",
  "A useful perk becomes ready.": "उपयोगी पुरस्कार तयार हुन्छ।",
  "Milestones and eligible offers turn into clear rewards without making customers track the math.":
    "ग्राहकले हिसाब राखिरहनु नपर्ने गरी उपलब्धि र योग्य अफरहरू स्पष्ट पुरस्कारमा बदलिन्छन्।",
  Ready: "तयार",
  "Complimentary coffee unlocked": "निःशुल्क कफी खुल्यो",
  "One secure scan": "एउटा सुरक्षित स्क्यान",
  "Value is simple to use.": "मूल्य प्रयोग गर्न सरल छ।",
  "The customer reveals a fresh QR only when the issuing business is ready to complete the redemption.":
    "जारी गर्ने व्यवसाय रिडेम्प्सन पूरा गर्न तयार भएपछि मात्र ग्राहकले नयाँ QR देखाउँछन्।",
  "Short-lived and business-bound": "छोटो समयका लागि र सम्बन्धित व्यवसायमा मात्र",
  "Across the network": "सञ्जालभरि",
  "Every eligible visit builds status.": "हरेक योग्य भ्रमणले सदस्यता तह बढाउँछ।",
  "Tier Points move members from Mero to Plus, Gold, and Elite while spendable balances stay separate.":
    "खर्च गर्न मिल्ने ब्यालेन्स अलग राख्दै टियर अंकले सदस्यलाई मेरोबाट प्लस, गोल्ड र एलिटसम्म पुर्‍याउँछ।",
  "550 Tier Points to Elite": "एलिटसम्म ५५० टियर अंक",
  "Free coffee": "निःशुल्क कफी",
  "Ready to use": "प्रयोग गर्न तयार",
  "One-time secure scan": "एकपटकको सुरक्षित स्क्यान",
  "A good reason to go back.": "फेरि फर्कने राम्रो कारण।",
  "Explore current offers from participating businesses. Sign in only when you are ready to redeem.":
    "सहभागी व्यवसायका हालका अफरहरू हेर्नुहोस्। रिडिम गर्न तयार भएपछि मात्र लग इन गर्नुहोस्।",
  "Search rewards or partners": "पुरस्कार वा साझेदार खोज्नुहोस्",
  "Filter by partner": "साझेदारअनुसार फिल्टर गर्नुहोस्",
  "We could not reach the live catalogue. Please retry to see current partner rewards.":
    "प्रत्यक्ष सूचीमा पुग्न सकिएन। हालका साझेदार पुरस्कार हेर्न फेरि प्रयास गर्नुहोस्।",
  "No rewards match those filters": "ती फिल्टरसँग मिल्ने पुरस्कार भेटिएनन्",
  "Try another partner or category, or clear your search.":
    "अर्को साझेदार वा श्रेणी छान्नुहोस्, वा खोज हटाउनुहोस्।",
  "Three ways loyalty works": "लोयल्टीले काम गर्ने तीन तरिका",
  "Earn here. Use it your way.": "यहाँ कमाउनुहोस्। आफ्नो तरिकाले प्रयोग गर्नुहोस्।",
  "Mero Perks keeps every kind of value easy to understand—so you always know what you earned, where it works, and what comes next.":
    "मेरो पर्क्सले हरेक प्रकारको मूल्य बुझ्न सरल बनाउँछ—तपाईंले के कमाउनुभयो, कहाँ प्रयोग हुन्छ र अब के आउँछ सधैँ थाहा हुन्छ।",
  "Every business keeps its rewards personal.": "हरेक व्यवसायका पुरस्कार छुट्टै रहन्छन्।",
  "Earn points from a business and redeem them with that same business. Your wallet shows each balance separately, exactly where it belongs.":
    "व्यवसायबाट अंक कमाउनुहोस् र त्यही व्यवसायमा रिडिम गर्नुहोस्। तपाईंको वालेटले प्रत्येक ब्यालेन्स सही ठाउँमा छुट्टाछुट्टै देखाउँछ।",
  "See participating rewards": "सहभागी पुरस्कारहरू हेर्नुहोस्",
  "One balance across participating places.": "सहभागी ठाउँहरूमा एउटै ब्यालेन्स।",
  "Mero Credits are platform-wide value. Earn them through eligible activity and use them at businesses that accept Mero Credits.":
    "मेरो क्रेडिट प्लेटफर्मभरि प्रयोग हुने मूल्य हो। योग्य गतिविधिबाट कमाउनुहोस् र मेरो क्रेडिट स्वीकार्ने व्यवसायमा प्रयोग गर्नुहोस्।",
  "Create your member wallet": "आफ्नो सदस्य वालेट बनाउनुहोस्",
  "AVAILABLE MERO CREDITS": "उपलब्ध मेरो क्रेडिट",
  "Ready at participating businesses": "सहभागी व्यवसायमा प्रयोग गर्न तयार",
  "Protected in your member wallet": "तपाईंको सदस्य वालेटमा सुरक्षित",
  "Your activity builds status—not spending money.":
    "तपाईंको गतिविधिले सदस्यता तह बढाउँछ—खर्च गरिएको पैसाले होइन।",
  "Tier Points track eligible activity across the Mero Perks network. They are never redeemed; they simply move you toward more recognition.":
    "टियर अंकले मेरो पर्क्स सञ्जालभरिका योग्य गतिविधि ट्र्याक गर्छ। यी रिडिम हुँदैनन्; यसले तपाईंलाई थप मान्यतातर्फ अघि बढाउँछ।",
  "Explore membership tiers": "सदस्यता तहहरू हेर्नुहोस्",
  "Membership that grows with you": "तपाईंसँगै बढ्ने सदस्यता",
  "Four tiers. One rewarding journey.": "चार तह। एउटा पुरस्कारमय यात्रा।",
  "Start as a Mero member, then build Tier Points across the network to reach Plus, Gold, and Elite.":
    "मेरो सदस्यबाट सुरु गरी सञ्जालभरि टियर अंक बढाउँदै प्लस, गोल्ड र एलिटसम्म पुग्नुहोस्।",
  "Your journey begins": "तपाईंको यात्रा सुरु हुन्छ",
  "Tier Points": "टियर अंक",
  "A participating local retail business": "सहभागी स्थानीय खुद्रा व्यवसाय",
  "Turn first visits into familiar faces.": "पहिलो भ्रमणलाई परिचित अनुहारमा बदल्नुहोस्।",
  "Launch earning rules, offers, tiers, and secure checkout tools designed around the way your business actually works.":
    "तपाईंको व्यवसायले काम गर्ने तरिकाअनुसार बनाइएका कमाइ नियम, अफर, तह र सुरक्षित चेकआउट उपकरण सुरु गर्नुहोस्।",
  "Become a Mero partner": "मेरो साझेदार बन्नुहोस्",
  "Ready for more?": "थपका लागि तयार हुनुहुन्छ?",
  "Make your next visit count.": "आफ्नो अर्को भ्रमणलाई अर्थपूर्ण बनाउनुहोस्।",
  "Join once, discover nearby businesses, and keep every reward within reach.":
    "एकपटक जोडिनुहोस्, नजिकका व्यवसाय खोज्नुहोस् र हरेक पुरस्कार सहजै पहुँचमा राख्नुहोस्।",
  "Login to redeem": "रिडिम गर्न लग इन गर्नुहोस्",
};

const Context = createContext<{ language: Language; setLanguage: (language: Language) => void }>({
  language: "en",
  setLanguage: () => undefined,
});

const translate = (value: string, language: Language) =>
  language === "ne" ? (authNe[value] ?? marketingNe[value] ?? ne[value] ?? value) : value;

export function I18nProvider({ children }: { children: ReactNode }) {
  const [language, setLanguageState] = useState<Language>(() =>
    localStorage.getItem("mero-language") === "ne" ? "ne" : "en",
  );
  const originals = useRef(new WeakMap<Text, string>());
  const attributeOriginals = useRef(new WeakMap<Element, Record<string, string>>());
  const setLanguage = (next: Language) => {
    localStorage.setItem("mero-language", next);
    setLanguageState(next);
  };
  useEffect(() => {
    document.documentElement.lang = language === "ne" ? "ne" : "en";
    const root = document.getElementById("root");
    if (!root) return;
    let applying = false;
    const applyText = (node: Text) => {
      if (node.parentElement?.closest('[data-i18n-ignore="true"]')) return;
      const current = node.nodeValue ?? "";
      if (language === "en") {
        const original = originals.current.get(node);
        if (original !== undefined && current !== original) node.nodeValue = original;
        return;
      }
      if (!originals.current.has(node)) originals.current.set(node, current);
      const original = originals.current.get(node) ?? current;
      const trimmed = original.trim();
      const localized = translate(trimmed, language);
      const desired = localized !== trimmed ? original.replace(trimmed, localized) : original;
      if (current !== desired) node.nodeValue = desired;
    };
    const applyAttributes = (element: Element) => {
      if (element.closest('[data-i18n-ignore="true"]')) return;
      const supported = ["aria-label", "placeholder", "title", "alt"];
      const originalsForElement = attributeOriginals.current.get(element) ?? {};
      supported.forEach((name) => {
        const current = element.getAttribute(name);
        if (current === null) return;
        if (!(name in originalsForElement)) originalsForElement[name] = current;
        const original = originalsForElement[name] ?? current;
        const desired = translate(original, language);
        if (current !== desired) element.setAttribute(name, desired);
      });
      attributeOriginals.current.set(element, originalsForElement);
    };
    const applyTree = (target: Node) => {
      applying = true;
      if (target.nodeType === Node.TEXT_NODE) applyText(target as Text);
      else {
        if (target instanceof Element) applyAttributes(target);
        const walker = document.createTreeWalker(target, NodeFilter.SHOW_TEXT);
        let node = walker.nextNode();
        while (node) {
          applyText(node as Text);
          node = walker.nextNode();
        }
        if (target instanceof Element)
          target
            .querySelectorAll("[aria-label], [placeholder], [title], [alt]")
            .forEach(applyAttributes);
      }
      applying = false;
    };
    applyTree(root);
    const observer = new MutationObserver((mutations) => {
      if (applying) return;
      mutations.forEach((mutation) => {
        if (mutation.type === "characterData") applyTree(mutation.target);
        if (mutation.type === "attributes") applyTree(mutation.target);
        mutation.addedNodes.forEach(applyTree);
      });
    });
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ["aria-label", "placeholder", "title", "alt"],
    });
    return () => {
      observer.disconnect();
    };
  }, [language]);
  const value = useMemo(() => ({ language, setLanguage }), [language]);
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

function LanguageFlag({ language }: { language: Language }) {
  if (language === "en") {
    return (
      <svg viewBox="0 0 28 20" aria-hidden="true" focusable="false">
        <rect width="28" height="20" rx="2" fill="#fff" />
        {[0, 4, 8, 12, 16].map((y) => (
          <rect key={y} y={y} width="28" height="2" fill="#c8102e" />
        ))}
        <path d="M0 0h13v11H0z" fill="#122937" />
        <path
          d="m2.4 2 .7 1.4 1.5.2-1.1 1 .3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1 1.5-.2zm4 0 .7 1.4 1.5.2-1.1 1 .3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1 1.5-.2zm4 0 .7 1.4 1.5.2-1.1 1 .3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1 1.5-.2zM4.4 6l.7 1.4 1.5.2-1.1 1 .3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1 1.5-.2zm4 0 .7 1.4 1.5.2-1.1 1 .3 1.5-1.4-.7-1.4.7.3-1.5-1.1-1 1.5-.2z"
          fill="#fff"
        />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 28" aria-hidden="true" focusable="false">
      <path d="M1 1v26h21L8 16h11L1 1z" fill="#1b4f9c" />
      <path d="M3 4v20h13L6 15h9L3 4z" fill="#dc143c" />
      <path
        d="m7.5 8 .8 1.7 1.8.2-1.3 1.2.4 1.8-1.7-.9-1.6.9.3-1.8-1.3-1.2 1.8-.2zM7.5 18a2.3 2.3 0 1 0 0 4.6 2.3 2.3 0 0 0 0-4.6z"
        fill="#fff"
      />
    </svg>
  );
}

export function LanguageSwitch() {
  const { language, setLanguage } = useContext(Context);
  const [open, setOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const dismiss = (event: PointerEvent) => {
      if (!rootRef.current?.contains(event.target as Node)) setOpen(false);
    };
    const dismissWithKeyboard = (event: KeyboardEvent) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("pointerdown", dismiss);
    document.addEventListener("keydown", dismissWithKeyboard);
    return () => {
      document.removeEventListener("pointerdown", dismiss);
      document.removeEventListener("keydown", dismissWithKeyboard);
    };
  }, []);

  const choose = (next: Language) => {
    setLanguage(next);
    setOpen(false);
  };

  return (
    <div
      className={`language-switch ${open ? "is-open" : ""}`}
      data-i18n-ignore="true"
      ref={rootRef}
    >
      <button
        type="button"
        className="language-switch__trigger"
        aria-label={language === "en" ? "Language: English" : "भाषा: नेपाली"}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => {
          setOpen((current) => !current);
        }}
      >
        <span className="language-switch__flag">
          <LanguageFlag language={language} />
        </span>
        <span className="language-switch__current">{language === "en" ? "English" : "नेपाली"}</span>
        <span className="language-switch__chevron" aria-hidden="true">
          ⌄
        </span>
      </button>
      {open && (
        <div
          className="language-switch__menu"
          role="menu"
          aria-label={language === "en" ? "Choose language" : "भाषा छान्नुहोस्"}
        >
          <button
            type="button"
            role="menuitemradio"
            aria-checked={language === "en"}
            className={language === "en" ? "is-active" : ""}
            onClick={() => {
              choose("en");
            }}
          >
            <span className="language-switch__option-flag">
              <LanguageFlag language="en" />
            </span>
            <span>English</span>
            <b aria-hidden="true">✓</b>
          </button>
          <button
            type="button"
            role="menuitemradio"
            aria-checked={language === "ne"}
            className={language === "ne" ? "is-active" : ""}
            onClick={() => {
              choose("ne");
            }}
          >
            <span className="language-switch__option-flag">
              <LanguageFlag language="ne" />
            </span>
            <span>नेपाली</span>
            <b aria-hidden="true">✓</b>
          </button>
        </div>
      )}
    </div>
  );
}
